module.exports = function(locale, preview = false) {
  return `{
      productCollection(locale:"${locale}", preview: ${preview}){
          items{
            sys {
                id
                firstPublishedAt
              }
              productCategoryType
              slug
              gtin
              maxPrice
              minPrice
              featuredSort
              breadcrumbTitle
              sitemapTitle
              ratingAndReviewId
              productName
              productShortName
              shortDescription
              parentPage{
                slug
              }
              variantsCollection(limit:5){
                items{
                  name
                  variantName
                  gtin
                }
              }
              productImage {
                title
                url
              }
              fecetCollection(limit: 20) {
                items {
                  sys {
                    id
                  }
                  name
                  title
                  facetCategory {
                    title
                    uniqueId
                  }
                }
              }
              heroImage {
                sys {
                  id
                }
                title
                url
                description
              }
              addedOn
          }
      }
    }
      `;
};
